import MachineBoard from "../shared";

export default function MachineRegistry() {
  return <MachineBoard mode="registry" />;
}
